/**
 * @voltxampere/ui — 7400 quad NAND TTL variant (Sprint 41-4)
 *
 * Reuses the op-amp triangle SVG as the MVP logic-gate visual. The
 * canvas pipeline is SVG-compiled and a dedicated NAND/NOR/AND/OR/
 * XOR/NOT bubble-pin glyph would be ~200 lines per gate; for this
 * sprint the user reads the gate function from the inspector card,
 * not the symbol shape. A future sprint can swap in proper
 * IEEE/IEC gate symbols once the MVP digital-gate stamp is
 * stabilised.
 *
 * Engine zero-diff invariant honored — variant maps to the canonical
 * `digital-gate` engine type via `schemaType`. The Sprint 41 DC
 * stamp consumes the `gateFunction: "NAND"` plus the rail/threshold
 * parameters from `defaultParams`.
 *
 * Reference: TI SN5400.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const logic7400 = {
    id: "7400",
    nameTr: "7400 (4'lü NAND, DIP-14)",
    nameEn: "7400 (Quad NAND, DIP-14)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "7400",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "NAND",
        vHigh: 2.4,
        vLow: 0.4,
        threshold: 1.4,
        propagationDelay: 10e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=logic-7400.js.map